import script from "./Details.vue?vue&type=script&lang=ts&setup=true"
export * from "./Details.vue?vue&type=script&lang=ts&setup=true"

import "./Details.vue?vue&type=style&index=0&id=c680abb6&lang=scss"

const __exports__ = script;

export default __exports__